import { Fetch, schemas, EditNotebookTitleBodyType } from '@convergence/client';
import { useMutation } from '@tanstack/react-query';
import { fetch } from '../fetch';
import { useQueryClient } from '@tanstack/react-query';

export async function editNotebookTitle(
  data: EditNotebookTitleBodyType,
  id: string,
  fetch: Fetch
) {
  return fetch(
    `/notebook/edit/${id}`,
    { method: 'PATCH', body: JSON.stringify(data) },
    schemas.NotebookDto
  );
}

export const useEditNotebookTitleMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['editNotebookTitle'],
    mutationFn: async ({
      data,
      id
    }: {
      data: EditNotebookTitleBodyType;
      id: string;
    }) => {
      const result = editNotebookTitle(data, id, fetch);
      return result;
    },
    onSuccess: async () => {
      console.log('saved new title');
      await queryClient.invalidateQueries({ queryKey: ['notebooks'] });
    }
  });
};
